<template>
  <div class="progress-chart">
    <raw-progress-chart :data="refinedData" :options="options" :width="width" :height="height"></raw-progress-chart>
    <div class="label" :style="fontSize">{{ value }}</div>
  </div>
</template>

<script>
import RawProgressChart from '@/components/charts/RawProgressChart.js'

export default {
  name: 'ProgressChart',
  components: {
    RawProgressChart
  },
  props: ['data', 'options', 'width', 'height'],
  data() {
    return {

    }
  },
  computed: {
    refinedData() {
      return this.data ? this.data : 0
    },
    fontSize() {
      return 'font-size:' + Math.min(this.width/4, 26) + 'px'
    },
    value() {
      return (this.refinedData * 100).toFixed(0) + ' %'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
